import { render, staticRenderFns } from "./customerScaleDetail.vue?vue&type=template&id=2e094cc0&scoped=true"
import script from "./customerScaleDetail.vue?vue&type=script&lang=js"
export * from "./customerScaleDetail.vue?vue&type=script&lang=js"
import style0 from "./customerScaleDetail.vue?vue&type=style&index=0&id=2e094cc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e094cc0",
  null
  
)

export default component.exports